/* HC PDP V2 — vanilla controller (carousel, before/after, sticky ATC, scroll reveals) */
(function () {
  'use strict';

  // -------- Mark <html> + <body> for scoped styles
  document.documentElement.classList.add('hc-pdp-html');
  document.body.classList.add('hc-pdp-body');

  // -------- Carousel (scroll-snap based, JS only manages dots + a11y)
  function initCarousel(root) {
    var track = root.querySelector('.hc-carousel__track');
    var slides = root.querySelectorAll('.hc-carousel__slide');
    var dotsWrap = root.querySelector('.hc-carousel__dots');
    if (!track || !slides.length || !dotsWrap) return;

    // Build dots
    dotsWrap.innerHTML = '';
    slides.forEach(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'hc-carousel__dot';
      b.setAttribute('aria-label', 'Imagen ' + (i + 1) + ' de ' + slides.length);
      if (i === 0) b.setAttribute('aria-current', 'true');
      b.addEventListener('click', function () {
        track.scrollTo({ left: slides[i].offsetLeft, behavior: 'smooth' });
      });
      dotsWrap.appendChild(b);
    });
    var dots = dotsWrap.querySelectorAll('.hc-carousel__dot');

    // Sync dots with scroll
    var raf = null;
    track.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var w = track.clientWidth;
        var idx = Math.round(track.scrollLeft / w);
        dots.forEach(function (d, j) {
          if (j === idx) d.setAttribute('aria-current', 'true');
          else d.removeAttribute('aria-current');
        });
      });
    }, { passive: true });

    // Keyboard nav
    track.setAttribute('tabindex', '0');
    track.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      var w = track.clientWidth;
      var dir = e.key === 'ArrowRight' ? 1 : -1;
      track.scrollBy({ left: dir * w, behavior: 'smooth' });
    });
  }

  // -------- Before/After slider
  function initBA(root) {
    var wrap   = root.querySelector('.hc-ba__wrap');
    var after  = root.querySelector('.hc-ba__layer--after');
    var handle = root.querySelector('.hc-ba__handle');
    var knob   = root.querySelector('.hc-ba__knob');
    if (!wrap || !after) return;

    var pct = 50;
    function setPct(p) {
      pct = Math.max(0, Math.min(100, p));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      handle.style.left = pct + '%';
      knob.style.left   = pct + '%';
    }
    function fromEvent(e) {
      var rect = wrap.getBoundingClientRect();
      var x = (e.touches ? e.touches[0].clientX : e.clientX) - rect.left;
      setPct((x / rect.width) * 100);
    }
    var dragging = false;
    function down(e) { dragging = true; fromEvent(e); e.preventDefault(); }
    function move(e) { if (dragging) fromEvent(e); }
    function up()    { dragging = false; }

    wrap.addEventListener('mousedown', down);
    wrap.addEventListener('touchstart', down, { passive: false });
    window.addEventListener('mousemove', move, { passive: true });
    window.addEventListener('touchmove', move, { passive: true });
    window.addEventListener('mouseup', up);
    window.addEventListener('touchend', up);
    setPct(50);
  }

  // -------- Purchase plan toggle (Subscribe&Save vs One-time)
  function initPurchasePlan() {
    var opts = document.querySelectorAll('.hc-pp-option');
    if (!opts.length) return;
    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        opts.forEach(function (x) { x.classList.remove('hc-pp-option--active'); });
        o.classList.add('hc-pp-option--active');
        // Update sticky ATC price
        var price = o.dataset.price;
        var save  = o.dataset.save;
        var plan  = o.dataset.plan || '';
        var pEl = document.querySelector('.hc-sticky-atc__price');
        var sEl = document.querySelector('.hc-sticky-atc__save');
        if (pEl && price) pEl.textContent = price;
        if (sEl) sEl.textContent = save || '';
        // Sync all hidden selling_plan inputs across forms (hero/sticky/final)
        document.querySelectorAll('input[name="selling_plan"]').forEach(function (inp) {
          inp.value = plan;
        });
      });
    });
  }

  // -------- Sticky ATC reveal after hero scrolls out
  function initStickyATC() {
    var atc  = document.querySelector('.hc-sticky-atc');
    var hero = document.querySelector('.hc-hero');
    if (!atc || !hero) return;
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        atc.dataset.visible = (!e.isIntersecting).toString();
      });
    }, { threshold: 0.05 });
    obs.observe(hero);
  }

  // -------- Scroll reveals
  function initReveals() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(max-width: 767px)').matches) return;
    var els = document.querySelectorAll('.hc-reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });
    els.forEach(function (el) { io.observe(el); });
  }

  // -------- Bootstrap
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }
  ready(function () {
    document.querySelectorAll('.hc-carousel').forEach(initCarousel);
    document.querySelectorAll('.hc-ba').forEach(initBA);
    initPurchasePlan();
    initStickyATC();
    initReveals();
  });
})();
